<script lang="ts" setup>
import useStore from "@src/stores/store";
import { ArrowLeftOnRectangleIcon, Cog6ToothIcon, QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import { useAuthStore } from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import Dropdown from "@src/components/ui/navigation/Dropdown/Dropdown.vue";

const sessionStore = useChatSessionStore()

const props = defineProps<{
    showDropdown: boolean;
    handleCloseDropdown: () => void;
    handleShowDropdown: () => void;
    id: string;
}>();

const store = useStore();
const authStore = useAuthStore();

const handleCloseOnClickOutside = (event: Event) => {
    if (!["user-avatar", "profile-menu-button"].includes((event.target as HTMLButtonElement).id)) {
        props.handleCloseDropdown();
    }
};

const getProfilePicture = () => {
    if (!authStore.user) {
        return ''
    }
    const avatar = authStore.user?.profile_photo_path ?? authStore.user?.profile_photo_url;

    return encodeURI((avatar.startsWith('http')) ? avatar : 'https://cdn.dchat.com.br/' + avatar);
};

const handleOpenSettings = () => {
    store.activeSidebarComponent = "settings";
    props.handleCloseDropdown();
};

const handleLogout = async () => {
    try {
        await authStore.logout();
    } catch (e) {
        console.error(e);
    } finally {
        store.goToLogin();
        sessionStore.clearSession()
        indexedDB.deleteDatabase("dChatDatabase");
        props.handleCloseDropdown();
    }
};
</script>

<template>
    <div class="relative z-50">
        <button
            :id="props.id + '-button'"
            :aria-expanded="showDropdown"
            :style="{
        'box-shadow': !store.settings.darkMode
          ? '0 .125rem .3125rem rgba(193, 202, 255, 0.5),.125rem 0 .3125rem rgba(193, 202, 255, 0.5),-0. 125rem 0 .3125rem rgba(193, 202, 255, 0.5),0 -0.125rem .3125rem rgba(193, 202, 255, 0.5)'
          : '0 .125rem .3125rem rgba(0, 70, 128, 0.5),.125rem 0 .3125rem rgba(0, 70, 128, 0.5),-0.125rem 0 .3125rem rgba(0, 70, 128, 0.5),0 -0.125rem .3125rem rgba(0, 70, 128, 0.5)',
      }"
            aria-controls="profile-menu"
            aria-label="toggle profile menu"
            class="bg-white rounded-full active:scale-110 focus:outline-none focus:scale-110 transition duration-200 ease-out cursor-pointer"
            @click="handleShowDropdown"
        >
            <div
                id="user-avatar"
                :style="{ backgroundImage: `url(${getProfilePicture()})` }"
                class="w-7 h-7 rounded-full bg-cover bg-center"
            ></div>
        </button>

        <Dropdown
            :id="props.id + '-dropdown'"
            :aria-labelledby="props.id + '-button'"
            :close-dropdown="props.handleCloseDropdown"
            :handle-click-outside="handleCloseOnClickOutside"
            :position="['md:bottom-0','md:left-8','md:top-auto','bottom-12.5','left-[-4.8125rem]']"
            :show="props.showDropdown"
            class="z-50"
        >

          <!-- SUPORTE -->
          <a
              href="https://wa.link/ccz074"
              target="_blank"
              rel="noopener noreferrer"
              class="cursor-pointer dropdown-link dropdown-link-primary"
              role="menuitem"
          >
            <QuestionMarkCircleIcon class="h-5 w-5 mr-3" />
            Suporte
          </a>


          <!-- CONFIGURAÇÕES -->
            <button
                aria-label="open settings"
                class="cursor-pointer dropdown-link dropdown-link-primary"
                role="menuitem"
                @click="handleOpenSettings"
            >
                <Cog6ToothIcon class="h-5 w-5 mr-3 text-black opacity-60 dark:text-white dark:opacity-70" />
                Configurações
            </button>

            <!-- SAIR -->
            <button
                aria-label="logout"
                class="cursor-pointer dropdown-link dropdown-link-danger"
                role="menuitem"
                @click="handleLogout"
            >
                <ArrowLeftOnRectangleIcon class="h-5 w-5 mr-3" />
                Sair
            </button>
        </Dropdown>
    </div>
</template>
